import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as stockAction from '../../../../actions/stockAction';
import { BackButton, Button, Input, Title, Collapsible, InfiniteScroll, Select, Modal} from '../../../../components/UI/ComponentsUI';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { closeCollapsible, downloadFile, formatData, getUserNameToName, showMessageToast, showMessageToastCustom, translate } from '../../../../utils/util';

const SqpList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            type: ENUMS.eFormType.Sqp.value,
            partNumberCode: undefined,
            mvmNumber: undefined,
            journey: undefined,
            invoice: undefined,
            updateBy: undefined,
            updateOn: undefined,
            finished: undefined
        });
    const [sqps, setSqps] = useState([]);
    const [openModalIsCarriedOut, setOpenModalIsCarriedOut] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [isCarriedOut, setIsCarriedOut] = useState();
    const [selectedId, setSelectedId] = useState();


    useEffect(() => {
        getSqps();
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (props.sqps?.items?.length > 0) {
            if (sqps.length > 0 && currentPage === 0) {
                setSqps([...props.sqps.items]);
            } else {
                setSqps((prevState) => ([...prevState, ...props.sqps.items]));
            }
        } else {
            setSqps([]);
        }
        // eslint-disable-next-line
    }, [props?.sqps?.items]);

    const getSqps = () => {
        if (validateInputsRequired("formfilter")) {
            Object.assign(filter, {
                PageSize: 20,
                PageIndex: currentPage
            });
            props.getSqps(filter, () => {
                closeCollapsible("collapsible2")
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItem = (item) => {
        if (item.finished) {
            showMessageToast({ html: translate('finishedForm', 'stock'), classes: 'red' });
            return false;
        }
        props.selectSqp(item)
        props.history.push({
            pathname: './sqp/update',
            state: { update: true, sqpId: item.id }
        })
    }

    const report = (id) => {
        props.reportSqp(id, (response) => {
            downloadFile(response, `sqp${id}.pdf`, "data:application/pdf", true)
        })
    }

    const handleMvmJourney = (item) => {
        let text = '';
        if (item.mvmNumber) {
            text = text + item.mvmNumber;

            if (item.journey) text = text + item.journey
        } else {
            text = text + item.journey
        }
        return text;
    }

    const finish = (id) => {
        setSelectedId(id);
        setOpenModalIsCarriedOut(true);
    }

    const downloadListReport = () => {
        if (validateInputsRequired("formfilter")) {
            props.getListReport(filter, (response) => {
                downloadFile(response, `sqp.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true);
                closeCollapsible("collapsible2")
            });
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-comment-question-outline" label={translate('sqp', 'stock')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '25px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <>
                                <div id="formfilter" className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="partNumberCode"
                                            name='partNumberCode'
                                            label={translate('stock:form.partnumber')}
                                            type="text"
                                            defaultValue={filter?.partNumberCode || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="mvmNumber"
                                            name='mvmNumber'
                                            label={translate('stock:form.mvm')}
                                            type="text"
                                            defaultValue={filter?.mvmNumber || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="journey"
                                            name='journey'
                                            label={translate('stock:form.journey')}
                                            type="text"
                                            defaultValue={filter?.journey || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="invoice"
                                            name='invoice'
                                            label={translate('stock:form.invoice')}
                                            type="text"
                                            defaultValue={filter?.invoice || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="updateBy"
                                            name='updateBy'
                                            label={translate('stock:form.user')}
                                            type="text"
                                            defaultValue={filter?.updateBy || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="updateOn"
                                            name='updateOn'
                                            label={translate('stock:form.date')}
                                            type="date"
                                            defaultValue={filter?.updateOn || ''}
                                            onChange={onChange}
                                            maxLength="100"
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            id="finished"
                                            display="name"
                                            placeHolder={translate('choose-one-option', 'general')}
                                            label={translate('finished', 'stock')}
                                            data={[
                                                { id: true, text: 'Somente Finalizados' },
                                                { id: false, text: 'Somente não finalizados' },
                                            ]}
                                            defaultValue=""
                                            change={(e) => {
                                                setFilter({ ...filter, finished: e.target.value });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text={translate('search', 'general')} onClick={() => getSqps()} />
                                </div>
                            </>
                        }
                    />
                    {
                        sqps.length > 0 &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text={translate('download-list', 'general')} onClick={() => downloadListReport()} />
                        </div>
                    }
                </div>
                <div id="listsqp">
                    <InfiniteScroll
                        page={props.sqps?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        hasMore={currentPage < props.sqps?.totalPages ? true : false}
                        data={sqps.map((item, index) =>
                            <div
                                key={index}
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px' }}
                            >
                                <div onClick={() => onSelectItem(item)}>
                                    <span className="title sixth-text-color" style={{ display: 'block' }}>{handleMvmJourney(item)}</span>
                                    <span className="title sixth-text-color" style={{ display: 'block' }}>{item.invoice}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>SQP Efetivado? {item.isCarriedOut ? "SIM" : "NÃO"}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>{formatData(item?.updatedOn)}</span>
                                    <span className="sixth-text-color" style={{ marginLeft: '10px' }}>{getUserNameToName(props?.usersFromElog, item?.updatedBy)}</span>
                                </div>
                                <span className="title sixth-text-color right">
                                    <i style={{ cursor: 'pointer' }} onClick={() => report(item.id)} className="mdi mdi-printer"></i>
                                    {!item?.finished && (
                                        <i style={{ cursor: 'pointer', padding: 6 }} onClick={() => finish(item.id)} className="mdi mdi-check-all m1"></i>
                                    )}
                                </span>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Modal
                open={openModalIsCarriedOut}
                maxHeight="45%"
                id="ModalIsCarriedOut"
                title={`A DEEM foi efetivada no sistema de origem?`}
                dismissible={false}
                onConfirm={() => {
                    setIsCarriedOut(true);
                    setOpenModalIsCarriedOut(false);
                    setOpenModalConfirm(true);
                }}
                onCancel={() => {
                    setIsCarriedOut(false);
                    setOpenModalIsCarriedOut(false);
                    setOpenModalConfirm(true);
                }}
                btnConfirm="Sim"
                btnCancel="Não"
            />
            <Modal
                open={openModalConfirm}
                maxHeight="45%"
                id="ModalConfirm"
                title={`Confirmar finalização?`}
                dismissible={false}
                onConfirm={() => {
                    props.finishForm(selectedId, isCarriedOut, (response) => {
                        showMessageToastCustom(translate('success', 'general'), translate('finishedSuccess', 'stock'), 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        getSqps();
                    })
                    setOpenModalConfirm(false);
                }}
                onCancel={() => {
                    setOpenModalConfirm(false);
                }}
                btnConfirm="Confirmar"
                btnCancel="Cancelar"
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        sqps: state.stockReducer.sqps,
        user: state.userReducer.user,
        usersFromElog: state.usersElogReducer.usersElog,
        sqp: state.stockReducer.sqp
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSqps: (filter, callback) => {
            dispatch(StockService.getFormPaged(filter, callback));
        },
        selectSqp: (selectSqp) => {
            dispatch(stockAction.setSqp(selectSqp));
        },
        reportSqp: (id, callback) => {
            dispatch(StockService.getReportSqp(id, callback));
        },
        finishForm: (id, isCarriedOut, callback) => {
            dispatch(StockService.finishForm(id, isCarriedOut, callback));
        },
        getListReport: (id, callback) => {
            dispatch(StockService.getListReport(id, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SqpList)));
